import type { StaticImageData } from 'next/image'

import IMG_01 from 'assets/images/lebensartakademie/01_selbstliebe_fuer_gluecksrebellinnen.png'
import IMG_02 from 'assets/images/lebensartakademie/02_lebensart_akademie_lebenskompetenzen.png'
import IMG_03 from 'assets/images/lebensartakademie/03_lebensart_akademie_identitaet.png'
import IMG_04 from 'assets/images/lebensartakademie/04_lebensart_akademie_leben_fliessen_lassen.png'
import IMG_05 from 'assets/images/lebensartakademie/05_lebensart_akademie_denken_bewusst_leben.png'
import IMG_06 from 'assets/images/lebensartakademie/06_lebensart_akademie_beziehung_gestalten.png'
import IMG_07 from 'assets/images/lebensartakademie/07_lebensart_akademie_ordnung.png'

export interface Course {
  image: StaticImageData;
  title: string;
  summary?: string;
  topics?: string[];
  url?: string;
  released: boolean;
}

export type Courses = { [key: string]: Course }

const courses: Courses = {
  '01_selbstliebe_fuer_gluecksrebellinnen': {
    released: true,
    image: IMG_01,
    title: 'Selbstliebe für Glücksrebellinnen',
    summary: `Selbstannahme lernen und praktizieren - für dein Leben nach deinen Wünschen nach Glück und Zufriedenheit`,
    // topics:
    // url: 'https://elopage.com/s/lebensart-akademie/selbstliebe-fuer-gluecksrebellinnen',
    url: '/lebensart-akademie/selbstliebe-fuer-gluecksrebellinnen'
  },
  '02_lebenskompetenzen_fuer_gluecksrebellinnen': {
    released: false,
    image: IMG_02,
    title: 'Lebenskompetenzen für Glücksrebellinnen',
    summary: `Baue deine Kompetenzen aus - für dein Leben nach deinen Wünschen. Steuerfrau sein in deinem Leben - die Unabhängigkeitserklärung`,
    topics: [
      'Selbsmanagementkompetenz',
      'Kommunikationskompetenz',
      'Konfliktlompetenz',
      'Durchsetzungskompetenz',
      'Beziehungskompetenz',
      'Lebensbalancekompetenz',
      'Glückskompetenz',
    ]
  },
  '03_identitaet': {
    released: false,
    image: IMG_03,
    title: 'Identität: Hingabe an den eigenen Wesenskern für Glücksrebellinnen',
    summary: `Wer bin ich eigentlich und warum? Wie möchte ich meine Lebenszeit nutzen und mein Leben ausfüllen? Welchen Beruf möchte ich ausüben? Autopilot aus - Leben an!`
  },
  '04_leben_fliessen_lassen': {
    released: false,
    image: IMG_04,
    title: 'Das Leben fließen lassen',
    summary: `Gestalte deine persönliche Lebensbalance`,
  },
  '05_denken_bewusst_lenken': {
    released: false,
    image: IMG_05,
    title: 'Denken, bewusst lenken',
    summary: `Fokusiere deine Gedanken bewusst auf das Gelingen und für dich Beeinflussbare`,
  },
  '06_beziehungen': {
    released: false,
    image: IMG_06,
    title: 'Beziehungen',
    summary: `Gestalte deine Beziehungen respektvoll und auf Augenhöhe`,
  },
  '07_ordnung': {
    released: false,
    image: IMG_07,
    title: 'Ordnung: Innen und Außen',
    summary: `Finde zur inneren Gelassenheit und Zufriedenheit durch die Herstellung deiner inneren und äußeren Ordnung`,
  },
}

export default courses
